import {
  getPreviousDays,
  getLastWeek,
  getPreviousWeek,
  getPreviousMonth,
  getQuarter,
  getYear,
  getCurrentMonth,
} from '@/helpers/date';

export const presets = {
  week: {
    lastRange: [
      {
        label: 'Last Week',
        range: getLastWeek(),
      },
    ],
    previousRange: [
      {
        label: 'Previous Week',
        range: getPreviousWeek(),
      },
    ],
  },
  multiOption: {
    daysRange: [
      {
        label: '30 Days',
        range: getPreviousDays({ rangeStartOffset: 30 }),
      },
      {
        label: '60 Days',
        range: getPreviousDays({ rangeStartOffset: 60 }),
      },
      {
        label: '90 Days',
        range: getPreviousDays({ rangeStartOffset: 90 }),
      },
      {
        label: '180 Days',
        range: getPreviousDays({ rangeStartOffset: 180 }),
      },
      {
        label: '360 Days',
        range: getPreviousDays({ rangeStartOffset: 360 }),
      },
    ],
    thisRange: [
      {
        label: 'This Month',
        range: getCurrentMonth(),
      },
      {
        label: 'This Quarter',
        range: getQuarter(0),
      },
      {
        label: 'This Year',
        range: getYear(0),
      },
    ],
    lastRange: [
      {
        label: 'Last Month',
        range: getPreviousMonth(),
      },
      {
        label: 'Last Quarter',
        range: getQuarter(1),
      },
      {
        label: 'Last Year',
        range: getYear(1),
      },
    ],
  },
};
